import { useState } from "react";

import { SVGSprite } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";

import OneOnOneYogaModal from "../OneOnOneYogaModal";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./OneOnOneYogaFloatingBanner.module.scss";

interface OneOnOneYogaFloatingBannerProps {}

const OneOnOneYogaFloatingBanner: React.FC<
  OneOnOneYogaFloatingBannerProps
> = () => {
  const cls = classNameGenerator(styles);

  const [showCallbackModal, setShowCallbackModal] = useState(false);

  const { data } = useAppSelector((state) => state.bootCamp);
  const {
    formSection: { label },
    currencySymbol,
    price,
  } = data?.trialData || { formSection: {} };

  return (
    <div className={cls("oneOnOneYogaFloatingBanner")}>
      <div className={cls("leftSection")}>
        {price ? (
          <div className={cls("pricingSection")}>
            <SVGSprite icon="icon-yoga-callback" className={cls("icon")} />
            <Typography
              variant="heading4"
              className={cls("title")}
              dangerouslySetInnerHTML={{
                __html: `Start your practice for just <br/><span class="price"><span class="currencySymbol">${currencySymbol}</span> ${price}<span/>`,
              }}
            />
          </div>
        ) : (
          <div className={cls("discountSection")}>
            <SVGSprite icon="icon-discount-icon-red" className={cls("icon")} />
            <Typography
              variant="heading4"
              className={cls("title")}
              dangerouslySetInnerHTML={{
                __html: `<span>50% off</span><br/> on your first enrolment`,
              }}
            />
          </div>
        )}
      </div>
      <div className={cls("rightSection")}>
        <button
          type="button"
          className={clsx(cls("heroCtaButton"), cls("darkColor"))}
          onClick={() => setShowCallbackModal(true)}
        >
          <span
            className={cls("heroCtaButtonText")}
            dangerouslySetInnerHTML={{
              __html: price ? `Book a class` : "Request a call back",
            }}
          />
          <span>{arrowIcon}</span>
        </button>
      </div>
      <OneOnOneYogaModal
        showModal={showCallbackModal}
        setShowModal={setShowCallbackModal}
      />
    </div>
  );
};

export default OneOnOneYogaFloatingBanner;

const arrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M6.5 13L10.5 9L6.5 5"
      stroke="#ffffff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
